import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Catalogs|Credentials|Card|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Credential,
	portal: 'SP',
};

type LocNameStart = 'SPCatalogsCredentialCard';
export type SPCatalogsCredentialCardLocNames =
	| `${LocNameStart}ButtonChange`
	| `${LocNameStart}TitlePage`;

export const spCatalogsCredentialCardLocs: LocDefs<SPCatalogsCredentialCardLocNames> = {
	SPCatalogsCredentialCardButtonChange: {
		defaultValue: 'Change',
		description: 'Change credential button',
		displayPath: `${pathStart}Change`,
		displayType: 'Button',
		legacyName: 'Credential/Catalogs.Credentials.Button.ChangeSelectedCredential',
		...sharedProperties,
	},
	SPCatalogsCredentialCardTitlePage: {
		defaultValue: 'Credentials Catalog',
		description: 'Page title',
		displayPath: `${pathStart}Page title`,
		displayType: 'Title',
		legacyName: 'Credential/Catalogs.Credentials.Title.CatalogPageTitle',
		...sharedProperties,
	},
};

export type SPCatalogsCredentialCardLocType = LocMap<SPCatalogsCredentialCardLocNames>;
